import { useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";

const dayOptions = [
  ["monday", "Lunes"],
  ["tuesday", "Martes"],
  ["wednesday", "Miercoles"],
  ["thursday", "Jueves"],
  ["friday", "Viernes"],
  ["saturday", "Sabado"],
  ["sunday", "Domingo"]
];

const defaultOpeningHours = () => dayOptions.reduce((days, [key]) => ({
  ...days,
  [key]: { open: "", close: "", closed: key === "sunday" }
}), {});

function StoreRegister() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [form, setForm] = useState({
    name: "",
    slug: "",
    email: "",
    phone: "",
    websiteUrl: "",
    instagramUrl: "",
    facebookUrl: "",
    tiktokUrl: "",
    discordUrl: "",
    whatsappUrl: "",
    openingHours: defaultOpeningHours(),
    addressLine: "",
    city: "",
    country: "",
    description: ""
  });

  const submit = event => {
    event.preventDefault();
    setStatus("");
    api
      .post("/businesses/register", {
        ...form,
        socialLinks: {
          facebook: form.facebookUrl,
          tiktok: form.tiktokUrl,
          discord: form.discordUrl,
          whatsapp: form.whatsappUrl
        },
        openingHours: { days: form.openingHours }
      })
      .then(({ data }) => navigate(`/admin/${data.slug}`))
      .catch(error => setStatus(error?.response?.data?.error || "No se pudo registrar la tienda."));
  };

  const updateOpeningHour = (dayKey, field, value) => {
    setForm(current => ({
      ...current,
      openingHours: {
        ...current.openingHours,
        [dayKey]: {
          ...current.openingHours[dayKey],
          [field]: value,
          ...(field === "closed" && value ? { open: "", close: "" } : {})
        }
      }
    }));
  };

  return (
    <Container className="page-band store-page">
      <h1 className="section-title">Registrar tienda</h1>
      <p className="muted-copy">Crea el perfil de comunidad y solicita verificacion.</p>
      {status && <Alert variant="warning">{status}</Alert>}
      <Card className="cardora-card">
        <Card.Body>
          <Form className="admin-form-grid" onSubmit={submit}>
            <Row className="g-3">
              <Col md={6}>
                <Form.Label>Nombre</Form.Label>
                <Form.Control value={form.name} onChange={event => setForm({ ...form, name: event.target.value })} required />
              </Col>
              <Col md={6}>
                <Form.Label>Slug</Form.Label>
                <Form.Control value={form.slug} onChange={event => setForm({ ...form, slug: event.target.value })} placeholder="card-universe" />
              </Col>
              <Col md={6}>
                <Form.Label>Email</Form.Label>
                <Form.Control value={form.email} onChange={event => setForm({ ...form, email: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Telefono</Form.Label>
                <Form.Control value={form.phone} onChange={event => setForm({ ...form, phone: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Web</Form.Label>
                <Form.Control value={form.websiteUrl} onChange={event => setForm({ ...form, websiteUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Instagram</Form.Label>
                <Form.Control value={form.instagramUrl} onChange={event => setForm({ ...form, instagramUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Facebook</Form.Label>
                <Form.Control value={form.facebookUrl} onChange={event => setForm({ ...form, facebookUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>TikTok</Form.Label>
                <Form.Control value={form.tiktokUrl} onChange={event => setForm({ ...form, tiktokUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Discord</Form.Label>
                <Form.Control value={form.discordUrl} onChange={event => setForm({ ...form, discordUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>WhatsApp</Form.Label>
                <Form.Control value={form.whatsappUrl} onChange={event => setForm({ ...form, whatsappUrl: event.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label>Direccion</Form.Label>
                <Form.Control value={form.addressLine} onChange={event => setForm({ ...form, addressLine: event.target.value })} />
              </Col>
              <Col md={3}>
                <Form.Label>Ciudad</Form.Label>
                <Form.Control value={form.city} onChange={event => setForm({ ...form, city: event.target.value })} />
              </Col>
              <Col md={3}>
                <Form.Label>Pais</Form.Label>
                <Form.Control value={form.country} onChange={event => setForm({ ...form, country: event.target.value })} />
              </Col>
              <Col xs={12}>
                <Form.Label>Horarios</Form.Label>
                <div className="admin-hours-editor">
                  {dayOptions.map(([dayKey, label]) => {
                    const day = form.openingHours[dayKey] || { open: "", close: "", closed: false };
                    return (
                      <div className="admin-hour-row" key={dayKey}>
                        <span>{label}</span>
                        <Form.Check
                          type="switch"
                          label="Cerrado"
                          checked={Boolean(day.closed)}
                          onChange={event => updateOpeningHour(dayKey, "closed", event.target.checked)}
                        />
                        <Form.Control
                          type="time"
                          value={day.open || ""}
                          disabled={day.closed}
                          onChange={event => updateOpeningHour(dayKey, "open", event.target.value)}
                        />
                        <Form.Control
                          type="time"
                          value={day.close || ""}
                          disabled={day.closed}
                          onChange={event => updateOpeningHour(dayKey, "close", event.target.value)}
                        />
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col xs={12}>
                <Form.Label>Descripcion</Form.Label>
                <Form.Control as="textarea" rows={3} value={form.description} onChange={event => setForm({ ...form, description: event.target.value })} />
              </Col>
            </Row>
            <Button type="submit" className="btn-cardora mt-3">
              Registrar tienda
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default StoreRegister;
